<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editPassword.txt1')}}</span>
        <span>{{$t('editPassword.txt2')}} / {{$t('editPassword.txt3')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('editPassword.txt3')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="resetPass('editPasswordForm')">{{$t('editPassword.txt4')}}</div>
          <div class="searchBtn" @click="confirmPass('editPasswordForm')">{{$t('editPassword.txt5')}}</div>
        </div>
      </div>
      <div class="editForm passwordForm">
        <el-form :model="editPasswordForm" :rules="editPasswordRules" ref="editPasswordForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editPassword.txt6')" prop="password">
            <el-input
            :placeholder="$t('editPassword.txt7')"
            show-password
            v-model="editPasswordForm.password">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('editPassword.txt8')" prop="newPassword">
          <el-input
          :placeholder="$t('editPassword.txt9')"
          show-password
          v-model="editPasswordForm.newPassword">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editPassword.txt10')" prop="conPassword">
        <el-input
        :placeholder="$t('editPassword.txt11')"
        show-password
        v-model="editPasswordForm.conPassword">
      </el-input>
    </el-form-item>
  </el-form>
</div>
</el-card>
</div>
</template>

<script>
  import { crytoLogin } from "@/plugins/index.js";
  import qs from 'qs';
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('editPassword.txt12')));
        }
        else {
            callback();
          }
        };
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error(this.$t('editPassword.txt13')));
          }else if (value !== this.editPasswordForm.newPassword) {
            callback(new Error(this.$t('editPassword.txt14')));
          } else {
            callback();
          }
        };
        return {
          queryData:{},
          id:'',
        // 密码校验
        editPasswordRules:{
         password: [
         { required: true, message: this.$t('editPassword.txt7'), trigger: 'blur' },
         ],
         newPassword: [
         { required: true, message: this.$t('editPassword.txt9'), trigger: 'blur' },
         { min: 6, max: 18, message: this.$t('editPassword.txt15'), trigger: 'blur' },
         {required:true,validator:validatePass,trigger:'blur'},
         ],
         conPassword: [
         { required: true, message: this.$t('editPassword.txt12'), trigger: 'blur' },
         { min: 6, max: 18, message: this.$t('editPassword.txt15'), trigger: 'blur' },
         { required:true,validator: validatePass2, trigger: 'blur' },
         ],
       },
       editPasswordForm: {},//编辑密码参数
     };
   },
   created() {
   },
   methods: {
    onBack(){
      this.$router.go(-1);
    },
      // 确定提交修改密码
      confirmPass(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
                  this.password();
              } else {
                console.log('error submit!!');
                return false;
              }
            });
      },
        // 取消修改密码
        resetPass(formName) {
          this.$refs[formName].resetFields();
          this.onBack();
        },
         // 数据加载(用户管理列表)
         async password(){
          let data = {
            id:window.sessionStorage.getItem("userId"),
            password:crytoLogin(this.editPasswordForm.newPassword).rsaData,
            oldPassword:crytoLogin(this.editPasswordForm.password).rsaData,
          }
          const { data: res } = await this.$http.post("/user/info/update/password?"+qs.stringify(data));
          if(!res.success){
            return this.$message.error(res.message);
          }
          this.dialogFormEditPasswordVisible = false;
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.push("/login");
        },
      },
    };
  </script>

  <style lang="less" scoped>

    .handleBtn{
      padding: 0;
    }
    .userPage{
      /deep/ .el-upload__input{
        display: none !important;
      }
      /deep/ .el-date-editor .el-range-separator{
        margin-top: -5px;
        width: 8%;
      }
      .contactTitle{
        margin-bottom: 40px;
      }
      .contactTitle span{
        margin-right: 30px;
        cursor: pointer;
        font-size: 30px;
        font-weight: 500;
        color: #222222;
      }
      .w350{
        width: 350px;
      }
      .tips{      
        font-size: 1.4rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #98B9FF;
        margin-top: -10px;
      }
      .passwordForm{
        width: 50%;
        margin: 30px auto 260px auto;
        display: block;
      }
    }

  </style>
